import { AxiosResponse } from 'axios';
import api from 'api/base';
import {
  ExportAdminLogsParams,
  GetAdminLogCategoriesResponse,
  GetAdminLogRequestParams,
  GetAdminLogsResponseWithPagination,
} from 'features/admin-logs/api/types';

export const getAdminLogs = async (
  params: GetAdminLogRequestParams
): Promise<AxiosResponse<GetAdminLogsResponseWithPagination>> => {
  return api.get<GetAdminLogsResponseWithPagination>('/admin/logs', {
    params,
  });
};

export const getAdminLogCategories = async (): Promise<
  AxiosResponse<GetAdminLogCategoriesResponse>
> => {
  return api.get<GetAdminLogCategoriesResponse>('/admin/logs/categories');
};

export const exportAdminLogsAPI = async (
  params: ExportAdminLogsParams
): Promise<AxiosResponse<Blob>> => {
  return api.get<Blob>('admin/logs/download-report', {
    params,
    responseType: 'blob',
  });
};
